'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RhumbContext = require('./internal/RhumbContext');

var _RhumbContext2 = _interopRequireDefault(_RhumbContext);

var _ActionTypes = require('./internal/ActionTypes');

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _Scheduler = require('./internal/Scheduler');

var _performanceNow = require('./vendor/performanceNow');

var _performanceNow2 = _interopRequireDefault(_performanceNow);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavMarkerImplInner = function NavMarkerImplInner(_ref) {
  var name = _ref.name,
      id = _ref.id,
      dispatch = _ref.dispatch;

  (0, _react.useEffect)(function () {
    var marker = {
      name: name,
      id: id
    };

    var timestamp = (0, _performanceNow2.default)();

    (0, _Scheduler.runWithLowPriority)(function () {
      dispatch({
        type: ActionTypes.MARKER_MOUNTED,
        payload: {
          marker: marker,
          timestamp: timestamp
        }
      });
    });

    return function () {
      (0, _Scheduler.runWithLowPriority)(function () {
        dispatch({
          type: ActionTypes.MARKER_UNMOUNTED,
          payload: {
            marker: marker
          }
        });
      });
    };
  },
  // dispatch is guaranteed to be static
  [name, id, dispatch]);

  return null;
};

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  NavMarkerImplInner.propTypes = {
    name: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.number.isRequired,
    dispatch: _propTypes2.default.func.isRequired
  };
}

var NavMarkerImpl = function NavMarkerImpl(_ref2) {
  var name = _ref2.name;

  var context = (0, _react.useContext)(_RhumbContext2.default);

  if (context) {
    var id = context.id,
        dispatch = context.dispatch;


    return _react2.default.createElement(NavMarkerImplInner, { id: id, dispatch: dispatch, name: name });
  } else {
    // TODO devLogger? warn?
    return null;
  }
};

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  NavMarkerImpl.propTypes = {
    name: _propTypes2.default.string.isRequired
  };
}

var NavMarker = function NavMarker(_ref3) {
  var children = _ref3.children,
      name = _ref3.name,
      _ref3$active = _ref3.active,
      active = _ref3$active === undefined ? true : _ref3$active;
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    children,
    active && _react2.default.createElement(NavMarkerImpl, { name: name })
  );
};

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  NavMarker.propTypes = {
    name: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.node,
    active: _propTypes2.default.bool
  };
}

exports.default = NavMarker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.2431/js/NavMarker.js
// module id = 629
// module chunks = 3 4